// extracted by mini-css-extract-plugin
export default {"body":"NewAccount_body__MvCev","text":"NewAccount_text__8RVE9"};